import * as api from "@/api/williams/testEvents";
import { queryKeys } from "../../queryKeys";
import { useMutation, useQueryClient } from "react-query";

export function usePinTestEvent() {
  const queryClient = useQueryClient();

  return useMutation(async (id: string) => {
    await api.togglePinned(id);
    queryClient.refetchQueries(queryKeys.testEvent.filter({ favorite: true }));
  });
}
